module.exports = __webpack_public_path__ + "img/rcpy.769863cf.png";